import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import DOMPurify from "dompurify";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNf(true)); }, [slug]);

  if (nf) return <div className="py-32 text-center text-gray-500">Article introuvable. <Link to="/blog" className="text-brand-red">Retour</Link></div>;
  if (!post) return <div className="py-32 text-center text-gray-400">Chargement…</div>;

  return (
    <article className="mx-auto max-w-3xl px-4 py-12">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-brand-red mb-6"><ArrowLeft size={15} /> Articles</Link>
      <h1 className="font-heading text-4xl font-extrabold tracking-tight leading-tight">{post.title}</h1>
      <p className="text-sm text-gray-400 mt-3">Par {post.author}</p>
      {post.cover_image && <img src={post.cover_image} alt={post.title} className="w-full aspect-[16/9] object-cover mt-8 border border-gray-200" />}
      <div className="prose max-w-none mt-8 text-gray-700 leading-relaxed [&>p]:mb-4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content) }} />
    </article>
  );
}
